import { Document, FlattenMaps, Types } from "mongoose";
import userStatus from '../../userManagement/constant/userStatus.json'
import { TFunction } from "i18next";
import status from '../../Labour/constant/status.json'

export const StatusEnum = userStatus.statuses;
// export const InviteStatusEnum = userStatus.inviteStatuses;
export const NotificationPreferenceEnum = userStatus.notificationPreference;
export const RolesEnum = userStatus.roles;

export type StatusKey = keyof typeof StatusEnum;
export type StatusValue = typeof StatusEnum[StatusKey];

// export type InviteStatusKey = keyof typeof InviteStatusEnum;
// export type InviteStatusValue = typeof InviteStatusEnum[InviteStatusKey];

export type NotificationPreferenceKey = keyof typeof NotificationPreferenceEnum;
export type NotificationPreferenceValue = typeof NotificationPreferenceEnum[NotificationPreferenceKey];

export type RoleKey = keyof typeof RolesEnum;
export type RoleValue = typeof RolesEnum[RoleKey];




export interface IUser {
    _id?: string
    email: string;
    roleId: Types.ObjectId | FlattenMaps<{ name: string }>;
    profileImage?: Types.ObjectId | null
    failedLoginAttempts: number;
    lockUntil?: boolean;
    lastPasswordChange: Date;
    token?: string;
    tokenExpiry?: Date
    fullName?: string;
    otp?: string;
    otpExpiresAt?: Date;
    otpCreatedAt?: Date;
    isVerifiedOtp?: boolean;
    isVerifyOtpAt?: Date;
    failedOtpAttempts?: number;
    countryCode?: string
    joiningDate?: Date;
    isDeleted?: boolean;
    deletedAt?: Date;
    hasAcceptedTerms: boolean

    createdBy?: Types.ObjectId;
    permissions?: {
        permissionId: Types.ObjectId;
        grantedBy: Types.ObjectId
    }[];
    restrictedPermissions?: {
        permissionId: Types.ObjectId
        grantedBy: Types.ObjectId
    }[];
    onboardingTime?: Date

    status?: StatusValue;
    // inviteStatus?: InviteStatusValue;
    notificationPreferences?: NotificationPreferenceValue[];

    forgotPassword?: string;
    forgotpasswordTokenExpiry?: Date;
    // marital_status?: keyof typeof status.marital_status;
    isFirstTimeResetPassword?: boolean;
    isPasswordUpdate?: boolean;
    passwordUpdatedAt?: Date;

    createdAt?: Date;
    updatedAt?: Date;
    passwordExpiryDate: Date
    accountSetting: {
        userName?: string;
        passwordHash?: string;
        lastLogin?: Date;
    };

    sessionId: string
    refreshToken: string
    refreshTokenExpiry: Date
    isRememberMe: boolean


    invitedAt: Date
    acceptedInviteAt: Date
    firstName?: string
    lastName?: string
    phone?: string;
    // address?: string;
    gender?: keyof typeof status.Gender;
    date_of_birth?: Date;
    // nationality?: string;
    // emergency_contact_name?: string;
    // emergency_contact_phone?: string;
    // age?: number;

}


export interface DataStoredInToken {
    _id: string;
    role: string;
    email: string;
    passwordHash: string;
    sessionId: string;

}


export interface TokenData {
    token: string;
    expiresIn: string;
}

export interface IUserWithRoleName extends Omit<IUser, 'roleId'> {
    roleId: {
        name: string;
    };
}




export interface IUserResponse extends Document {
    email: string
    fullName: string
    roleName: string
    token: string
    joiningDate?: Date
    accountSetting?: {
        userName?: string;
        passwordHash?: string;
        lastLogin?: Date;
    };
    countryCode?: string
    // status?: (typeof StatusEnum)[keyof typeof StatusEnum];
    status?: StatusValue;
    notificationPreferences?: NotificationPreferenceValue[];
    profileImage?: {
        _id: string;
        filename: string;
        url: string;
        fileSize: number
    } | null;
    firstName: string
    lastName: string
}



export interface GetAllUsersParams {
    createdBy: string;
    page?: number;
    limit?: number;
    search?: string;
    roleFilter?: string;
    sortBy?: string;
    sortOrder?: string;
    filters?: Record<string, any>;
    t: TFunction;

}
